import imgPath from "@/common/img-path";
const state = {
    dialogData: false,
    dialogType: '',
    fullscreenLoading: false,
    // 搜索条件
    searchVal: '',
    searchCondition: {
      cateId: '',
      ext1: "",
      isTrainingCamp: '',
      name: "",
      pageNum: 1,
      pageSize: 12,
      sellerId: "",
      sortByHot: 0,
      sortByNew: 1
    },
    loginInfo: {
      status: false,
      name: ''
    },
    // 是否重置
    isReset: false,
    pageInfo: {
      total: 0
    },
    list: [],
    page: {
      style: {
        background: '#cc9999'
      }
    },
    userInfo: {
      photoImgUrl: imgPath.user_head,
      telPhone: ''
    }, // 用户数据
    jumpUrl: {
      path: '',
      query: {}
    },

  }
export default state;
